export default "<app-payment-forms [TLD]=\"TLD\" [Meta]=\"Meta\" [headerHeight]=\"headerHeight\"></app-payment-forms>\n";